/* eslint-disable no-console */
import { LoaderFunction } from 'react-router-dom';

import {
  ContentfulInstructorLedTraining,
  ContentfulInstructorLedTrainingResponse,
  GET_INSTRUCTOR_LED_TRAINING,
} from 'src/graphql/queries/GetInstructorLedTraining';
import { fetchGraphQL } from 'src/services/contentful/client';

interface GetILTQueryVariables {
  slug: string;
  preview: boolean;
}

const getInstructorLedTrainingData = async (
  slug: string,
  preview: boolean,
): Promise<ContentfulInstructorLedTraining | undefined> => {
  try {
    const response = await fetchGraphQL<ContentfulInstructorLedTrainingResponse, GetILTQueryVariables>(
      GET_INSTRUCTOR_LED_TRAINING,
      {
        slug,
        preview,
      },
    );

    return response.instructorLedTrainingCollection.items[0];
  } catch (error) {
    console.error('Error fetching ILT data:', error);

    return undefined;
  }
};

export interface LoaderResponse {
  courseId: string;
  iltData?: ContentfulInstructorLedTraining;
}

export const loader: LoaderFunction = async ({ params }): Promise<LoaderResponse | Response> => {
  const courseId = params.courseId ?? '';
  const preview = false;

  // TODO: Remove this enrollment check - private classes should not redirect
  // try {
  //   const res = await apiClient.adobe.getEnrollments({
  //     email: 'rknight@atlassian.com',
  //     aaid: '111',
  //   });

  //   // redirect to the session page if the enrollment is found
  //   if (res.data?.data) {
  //     const enrollment = res.data.data.find((item) => item.relationships?.learningObject?.data?.id === courseId);

  //     if (enrollment?.id) {
  //       // Parse ID format: "course:12547259_15145914_30579649"
  //       // Extract courseId (course:12547259) and instanceId (15145914)

  //       const idParts = enrollment.id.split(':')[1]?.split('_');

  //       const enrollmentCourseId = `course:${idParts[0]}`;
  //       const instanceId = idParts[1];

  //       return redirect(`/class/${enrollmentCourseId}/session/${instanceId}`);
  //     }
  //   }
  // } catch (error) {
  //   console.error('Error checking enrollment:', error);
  // }

  const iltData = await getInstructorLedTrainingData(courseId, preview);

  return {
    courseId,
    iltData,
  };
};
